import {
  Button,
  Image,
  Space,
  Text,
} from '@mantine/core';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import {
  createFileRoute,
} from '@tanstack/react-router';
import React from 'react';
import {
  useAuth,
} from 'react-oidc-context';

import ChartImg from '#resources/images/chart.png';
import SpeciaLogo2 from '#resources/images/logos/circle-specia-2.png';
import SecurityImg from '#resources/images/Security.png';
import Icons8Team from '#resources/images/team-splash.jpg';

export const Route = createFileRoute('/_app/_landing/')({
  component: Landing,
});

export function Landing(): React.ReactNode {
  const auth = useAuth();

  return (
    <>
      <div
        style={ {
          marginTop: '9vw',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyItems: 'center',
        } }
      >
        <Text
          ta="center"
          style={ {
            fontSize: '2.8vw',
            fontWeight: '400',
            color: 'rgb(255, 255, 255, 0.9)',
            letterSpacing: '0.05vw',
          } }
        >
          Powerful tool for accountants.
        </Text>
        <Text
          ta="center"
          style={ {
            fontWeight: '400',
            color: 'rgb(255, 255, 255, 0.7)',
            fontSize: '2.5vw',
            width: '47vw',
            marginTop: '0.5vw',
            lineHeight: '1.8vw',
            letterSpacing: '0.05vw',
          } }
        >
          Faster. Smarter. Accurate.
        </Text>
        <Text
          ta="justify"
          style={ {
            fontWeight: '300',
            color: 'rgb(255, 255, 255, 0.7)',
            fontSize: '0.9vw',
            width: '40vw',
            marginTop: '3vw',
            lineHeight: '1.8vw',
          } }
        >
          Specia Accountant is a cloud-based platform designed to
          streamline and enhance tax reporting for accountants.
          Leveraging advanced AI technology, it automates ATO report preparation and
          integrates seamlessly with accounting software, reducing time
          spent on repetitive tasks and improving accuracy.
        </Text>
        <Space
          h="lg"
        />
        <Button
          onClick={ () => auth.signinRedirect() }
        >
          Try out now
          <Space
            w="md"
          />
          <PlayCircleOutlineIcon />
        </Button>
      </div>
      <div
        style={ {
          width: '100%',
          padding: '0 2vw',
        } }
      >
        <div
          style={ {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '5vw',
          } }
        >
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: 'rgb(255, 255, 255, 0.025)',
              padding: '2vw',
              borderRadius: '1vw',
              alignItems: 'center',
            } }
          >
            <div
              style={ {
                flex: 2,
              } }
            >
              <Image
                w="100%"
                h="100%"
                p="3vw"
                radius="md"
                alt="Team Logo"
                src={ ChartImg }
              />
            </div>
            <div
              style={ {
                textAlign: 'left',
                padding: '1.5vw',
                flex: 5,
                paddingLeft: '2vw',
              } }
            >
              <p
                style={ {
                  fontSize: '1.7vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.9)',
                } }
              >
                Choosing Specia Accountant
              </p>
              <p
                style={ {
                  fontSize: '0.9vw',
                  lineHeight: '1.6vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.7)',
                } }
              >
                Specia Accountant is an AI-powered, cloud-based platform
                designed for accountants to streamline tax reporting and
                optimize workflows. With seamless integration to ATO, Xero,
                and MYOB, it automates tedious tasks, saving time and
                reducing costs. By enhancing client satisfaction and freeing
                up capacity, Specia Accountant not only drives immediate
                efficiency but also supports long-term business growth.
                Elevate your tax management process with a solution that’s
                precise, scalable, and built to transform the way you work.
              </p>
              <Button
                onClick={ () => {
                  auth.signinRedirect();
                } }
              >
                Learn More
              </Button>
              <div
                style={ {
                  display: 'flex',
                  flexDirection: 'row',
                } }
              >
                <div
                  style={ {
                    flex: 1,
                    marginRight: '1vw',
                  } }
                >
                  <p
                    style={ {
                      fontSize: '0.9vw',
                      color: 'rgb(255, 255, 255, 0.9',
                      fontWeight: '600',
                      marginBottom: '0.3vw',
                    } }
                  >
                    Integration
                  </p>
                  <p
                    style={ {
                      fontSize: '0.8vw',
                      color: 'rgb(255, 255, 255, 0.8',
                    } }
                  >
                    Connect ATO, Xero, and MYOB seamlessly.
                  </p>
                </div>
                <div
                  style={ {
                    flex: 1,
                    marginRight: '1vw',
                  } }
                >
                  <p
                    style={ {
                      fontSize: '0.9vw',
                      color: 'rgb(255, 255, 255, 0.9',
                      fontWeight: '600',
                      marginBottom: '0.3vw',
                    } }
                  >
                    Automation
                  </p>
                  <p
                    style={ {
                      fontSize: '0.8vw',
                      color: 'rgb(255, 255, 255, 0.8',
                    } }
                  >
                    AI-driven tasks for faster reporting.
                  </p>
                </div>
                <div
                  style={ {
                    flex: 1,
                    marginRight: '1vw',
                  } }
                >
                  <p
                    style={ {
                      fontSize: '0.9vw',
                      color: 'rgb(255, 255, 255, 0.9',
                      fontWeight: '600',
                      marginBottom: '0.3vw',
                    } }
                  >
                    Time
                  </p>
                  <p
                    style={ {
                      fontSize: '0.8vw',
                      color: 'rgb(255, 255, 255, 0.8',
                    } }
                  >
                    Minimize manual work, maximize efficiency.
                  </p>
                </div>
                <div
                  style={ {
                    flex: 1,
                    marginRight: '1vw',
                  } }
                >
                  <p
                    style={ {
                      fontSize: '0.9vw',
                      color: 'rgb(255, 255, 255, 0.9',
                      fontWeight: '600',
                      marginBottom: '0.3vw',
                    } }
                  >
                    Savings
                  </p>
                  <p
                    style={ {
                      fontSize: '0.8vw',
                      color: 'rgb(255, 255, 255, 0.8',
                    } }
                  >
                    Reduce costs with streamlined processes.
                  </p>
                </div>
                <div
                  style={ {
                    flex: 1,
                    marginRight: '1vw',
                  } }
                >
                  <p
                    style={ {
                      fontSize: '0.9vw',
                      color: 'rgb(255, 255, 255, 0.9',
                      fontWeight: '600',
                      marginBottom: '0.3vw',
                    } }
                  >
                    Satisfaction
                  </p>
                  <p
                    style={ {
                      fontSize: '0.8vw',
                      color: 'rgb(255, 255, 255, 0.8',
                    } }
                  >
                    Improve client trust and results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={ {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '5vw',
          } }
        >
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              borderRadius: '1vw',
              alignItems: 'center',
            } }
          >
            <div
              style={ {
                textAlign: 'left',
                flex: 2,
                paddingRight: '4vw',
              } }
            >
              <p
                style={ {
                  fontSize: '2.1vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.9)',
                  marginBottom: '2vw',
                } }
              >
                Efficiency
              </p>
              <p
                style={ {
                  fontSize: '1.1vw',
                  fontWeight: '400',
                  color: 'rgb(255, 255, 255, 0.9)',
                } }
              >
                Save Time and Reduce Costs with Automated Workflows and
                Efficient Tax Management
              </p>
              <p
                style={ {
                  fontSize: '0.9vw',
                  lineHeight: '1.6vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.7)',
                } }
              >
                Specia Accountant helps accountants optimize their workflow
                by automating repetitive tax tasks, reducing manual labor,
                and streamlining reporting processes. With advanced AI
                technology, our platform minimizes time spent on data entry,
                calculations, and compliance checks, while also lowering
                operational costs. By enhancing accuracy and efficiency,
                Specia Accountant allows you to focus on high-value tasks,
                driving both time and cost savings for your practice.
              </p>
              <Button
                onClick={ () => {
                  auth.signinRedirect();
                } }
              >
                Learn More
              </Button>
            </div>
            <div
              style={ {
                width: '10vw',
                flex: 2,
                textAlign: 'right',
                borderRadius: '1vw',
              } }
            >
              <Image
                w="100%"
                h="100%"
                radius="md"
                alt="Team splash"
                src={ Icons8Team }
              />
            </div>
          </div>
        </div>
        <div
          style={ {
            marginTop: '2vw',
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '5vw',
          } }
        >
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: 'rgb(255, 255, 255, 0.025)',
              padding: '2vw',
              borderRadius: '1vw',
              alignItems: 'center',
            } }
          >
            <div
              style={ {
                flex: 2,
              } }
            >
              <Image
                src={ SpeciaLogo2 }
                w="100%"
                h="100%"
                p="3vw"
                radius="md"
                alt="Specia logo"
              />
            </div>
            <div
              style={ {
                textAlign: 'left',
                padding: '1.5vw',
                flex: 5,
                paddingLeft: '2vw',
              } }
            >
              <p
                style={ {
                  fontSize: '1.7vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.9)',
                } }
              >
                Experience Effortless Tax Management with Powerful
                Integrations to ATO, Xero, and MYOB
              </p>
              <p
                style={ {
                  fontSize: '0.9vw',
                  lineHeight: '1.6vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.7)',
                } }
              >
                Specia Accountant connects seamlessly with ATO, Xero, and
                MYOB, giving accountants a unified platform for streamlined
                tax reporting and compliance. With real-time data syncing
                and reliable API integrations, our platform automates
                workflows across the tools you already use, ensuring
                accuracy, efficiency, and up-to-date reporting. Eliminate
                manual data entry and discover a fully connected solution
                for all your tax needs.
              </p>
            </div>
            <div
              style={ {
                width: '10vw',
                flex: 2,
              } }
            >
              <Button
                onClick={ () => {
                  auth.signinRedirect();
                } }
              >
                Try Now
                <Space
                  w="md"
                />
                <PlayCircleOutlineIcon />
              </Button>
            </div>
          </div>
        </div>
        <div
          style={ {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '5vw',
          } }
        >
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              borderRadius: '1vw',
              alignItems: 'center',
            } }
          >
            <div
              style={ {
                width: '10vw',
                flex: 2,
                textAlign: 'right',
                borderRadius: '1vw',
              } }
            >
              <Image
                w="100%"
                h="100%"
                radius="md"
                alt="Security logo"
                src={ SecurityImg }
              />
            </div>
            <div
              style={ {
                textAlign: 'left',
                flex: 2,
                paddingLeft: '4vw',
              } }
            >
              <p
                style={ {
                  fontSize: '2.1vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.9)',
                  marginBottom: '2vw',
                } }
              >
                Data Security
              </p>
              <p
                style={ {
                  fontSize: '1.1vw',
                  fontWeight: '400',
                  color: 'rgb(255, 255, 255, 0.9)',
                } }
              >
                Advanced Security Features Ensure Your Data is Encrypted,
                Private, and Fully Protected at All Times
              </p>
              <p
                style={ {
                  fontSize: '0.9vw',
                  lineHeight: '1.6vw',
                  fontWeight: '300',
                  color: 'rgb(255, 255, 255, 0.7)',
                } }
              >
                Specia Accountant prioritizes the security and
                confidentiality of your data with industry-leading
                encryption, multi-factor authentication, and regular
                compliance audits. Our platform is built with advanced
                security protocols to safeguard sensitive tax information
                and ensure that your data remains private and protected at
                all times. With Specia Accountant, you can focus on your
                work, knowing that your data is secure against threats and
                fully compliant with the highest standards of data
                protection.
              </p>
              <Button
                onClick={ () => {
                  auth.signinRedirect();
                } }
              >
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
